// extracted by mini-css-extract-plugin
module.exports = {"root":"baseView_root__3gYbl","main":"baseView_main__3mtf4","content":"baseView_content__32RI6"};